import { useState } from "react";
import AlertPopup from "./AlertPopup/AlertPopup";
import trans, { isRTL } from "../../../../utils";
import { Tooltip } from "antd";
import { FaInfoCircle } from "react-icons/fa";

export default function AlertsComponent(props) {
  const [alertPopup, setAlertPopup] = useState("");
  const isPopupDisabled = ["Idle Alerts", "Power Cut", "Total Alerts"].includes(
    props.title,
  );

  return (
    <>
      <div
        className="dashboard-alert"
        onClick={() => {
          if (!isPopupDisabled) setAlertPopup(props.title);
        }}
        dir={!isRTL ? "ltr" : "rtl"}
      >
        <div
          className={`bg-white-rounded p-12 flex-between my-3 ${
            isPopupDisabled ? "disabled-bg" : "cursor"
          }`}
        >
          <div>
            <p className="fs-12 fw-500 neutral-500">
              {trans(props.title)}{" "}
              {props.title === "Geofences Alerts" ? "" : trans("today")}
            </p>
            <div>
              <span className="fs-18 fw-700 neutral-800 me-3">
                {props.number}
              </span>
              {props.percent ? (
                props.percent > 0 ? (
                  <>
                    <span className="text-danger fs-12 fw-700">
                      {props.percent}
                    </span>
                    <Tooltip
                      title={trans("Increase in alerts compared to yesterday")}
                    >
                      <FaInfoCircle className="info-icon" size={20} />
                    </Tooltip>
                  </>
                ) : (
                  <>
                    <span className="brand-500 fs-12 fw-700">
                      {Math.abs(props.percent)}
                    </span>
                    <Tooltip
                      title={trans("Decrease in alerts compared to yesterday")}
                    >
                      <FaInfoCircle className="info-icon" size={20} />
                    </Tooltip>
                  </>
                )
              ) : (
                <span className="text-muted"></span>
              )}
            </div>
          </div>
          <div className="">
            <img
              src={`${process.env.PUBLIC_URL}/assets/${props.image}.svg`}
              alt=""
            />
          </div>
        </div>
      </div>
      {alertPopup && !isPopupDisabled && (
        <AlertPopup title={alertPopup} setAlertPopup={setAlertPopup} />
      )}
    </>
  );
}
